import { Component, OnInit, Inject } from '@angular/core';
import { DataService } from '../data.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-forma-pago-edit',
  templateUrl: './forma-pago-edit.component.html',
  styleUrls: ['./forma-pago-edit.component.css']
})
export class FormaPagoEditComponent implements OnInit {
  errMsg:any;
  okMsg:any;
  loading:boolean=false;
  tiempoMsg:number=3200;
  activo:boolean;
  esNuevo:boolean;
  grupo:any=[];
  resultado:any=[];
  esDuplicado: boolean = false;
  thisForm = new FormGroup({
    forma: new FormControl(this.data.item.forma, [Validators.required, Validators.minLength(3)]),
    descr: new FormControl(this.data.item.descrip, []),
  });

  constructor(private dataService: DataService, public dialogRef: MatDialogRef<FormaPagoEditComponent>, @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
    //console.log(this.data);
    if(this.data){
      if(this.data.id > 0)
        this.esNuevo=false;
      else
        this.esNuevo=true;
      this.activo = this.data.item.act
    }
  }

  fnGrupoCargado(){

  }

  fnKeyPress(t, e){
    this.errMsg="";
    if (!this.dataService.validKey(t,e)){
        this.errMsg="Caracter inválido!";
        setTimeout(() => {
            this.errMsg="";
        }, this.tiempoMsg);
        return false;
    }
    else
      return true;
  }

  fnKeyUp(t, e){
    //console.log(e);
  }

  onBlur(event){
    this.dataService.isFormaDup(this.thisForm.controls["forma"].value).subscribe(
                          rows => {   
                                  this.resultado = <any>rows
                                  },          
                          error => this.errMsg = <any>error,
                          () => this.fnFormaDuplicada());
  }

  fnFormaDuplicada(){
    this.esDuplicado = false;
    if(this.resultado > 0){
      this.fnMuestraMensaje("ERR", "La forma de pago ya ha sido dada de alta; elija otra o edite la existente.", false, false);
      this.thisForm.controls["forma"].markAsDirty();
      var aux = <HTMLInputElement>document.getElementById("txtForma");
      this.esDuplicado=true;
      aux.focus();
    }
  }

  fnMuestraMensaje(tipo:string, msg:string, changeLoading:boolean, closeDialog:boolean){
    this.okMsg = "";
    this.errMsg = "";
    if(tipo=="OK")
      this.okMsg = msg;
    if(tipo=="ERR")
      this.errMsg = msg;
    setTimeout(() => {
      this.okMsg = "";
      this.errMsg = "";
      if(changeLoading)
        this.loading = !this.loading;
      if(closeDialog)
        this.dialogRef.close();
    }, this.tiempoMsg);
  }

  fnDesactivar(){
    this.activo = false;
  }

  fnActivar(){
    this.activo = true;
  }

  fnGuardar(){
    this.loading = true;
    if(this.esNuevo){
      //console.log("GUARDAR");
      //--> Forma con nombre y mínimo 3 caracteres:
      if(this.thisForm.valid)
        this.dataService.insForma(this.thisForm.controls["forma"].value, this.activo, this.thisForm.controls["descr"].value).subscribe(
                        rows => {   
                                this.resultado = <any>rows
                                },          
                        error => this.errMsg = <any>error,
                        () => this.fnFormaGuardada());    
       
       else{
        //console.log(this.thisForm.controls["forma"].errors);
        if(this.thisForm.controls["forma"].errors.required)
          this.fnMuestraMensaje("ERR", "Capture una 'forma de pago'.", true, false)
        if(this.thisForm.controls["forma"].errors.minlength){
          //console.log(this.thisForm.controls["forma"].errors.minlength.actualLength);
          if(this.thisForm.controls["forma"].errors.minlength.actualLength < this.thisForm.controls["forma"].errors.minlength.requiredLength)
            this.fnMuestraMensaje("ERR", "La 'forma de pago' debe contener " + this.thisForm.controls["forma"].errors.minlength.requiredLength + " o más caracteres.", true, false)
        }
       }               
    }
    else{
      //console.log("EDITAR");
      //--> Nada que validar
      this.dataService.updForma(this.data.id, this.activo, this.thisForm.controls["descr"].value).subscribe(
                        rows => {   
                                this.resultado = <any>rows
                                },          
                        error => this.errMsg = <any>error,
                        () => this.fnFormaEditada());    
    }
  }

  fnFormaGuardada(){
    //console.log(this.resultado);
    if(this.resultado == 1){
      this.fnMuestraMensaje("OK", "Registro almacenado", false, true);
    }
    else{
      this.fnMuestraMensaje("ERR", "Error al almacenar registro", true, false);
      setTimeout(() => {
        this.loading = false;
      }, this.tiempoMsg);
    }
  }  

  fnFormaEditada(){
    //console.log(this.resultado);
    if(this.resultado == 1){
      this.okMsg = "Registro actualizado"
      setTimeout(() => {
        this.okMsg = "";
        this.loading = false;
        this.dialogRef.close();
      }, this.tiempoMsg);
    }
    else{
      this.errMsg = "Error al actualizar registro!"
      setTimeout(() => {
        this.errMsg = "";
        this.loading = false;
      }, this.tiempoMsg);
    }
  }
}
